var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classObject},_vm._l((_vm.row),function(achievement,i){return _c('SecretAchievement',{key:i,staticClass:"l-achievement-grid__cell",attrs:{"achievement":achievement}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }